export const API_URL = "https://app.cdri.world/icdri2023/public/api";
export const BACK_URL = "https://app.cdri.world/icdri2023/public";
//export const REGISTER_URL = "https://app.cdri.world/icdri2023/public/icdri-register";
export const REGISTER_URL = "https://icdri2023.com/register";
export const REGISTER_IN_PERSON_URL = "https://app.cdri.world/icdri2023/public/icdri-in-person";
export const ICDRI2022 = "https://app.cdri.world/icdri2022/public/";
export const ICDRI2021 = "https://app.cdri.world/icdri2021/";


// export const API_URL = "http://localhost:8000/api";
// export const BACK_URL = "http://localhost:8000";
// export const REGISTER_URL = "http://localhost:8000/icdri-register";
// export const REGISTER_IN_PERSON_URL = "http://localhost:8000/icdri-in-person";
// export const ICDRI2022 = "https://app.cdri.world/icdri2022/public/";
// export const ICDRI2021 = "https://app.cdri.world/icdri2021/";



